module.exports = __webpack_public_path__ + "static/media/success.b9fb0d3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success.svg
// module id = 539
// module chunks = 0